import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { Menu, Icon } from 'antd';
import { MENU_ITEMS, USER_ROLE } from './NavigationBarConstants';
import { bindActionCreators } from 'redux';
import { setNavigationKey } from '../../redux/action/navigation/NavigationActions';
import './NavigationBar.css';

class NavigationBar extends Component {
  handleClick = async (e) => {
    await this.props.setNavigationKey(e.key);

    const menuOptions = _.find(MENU_ITEMS, { key: e.key });
    this.props.history.push(menuOptions.path);
  };

  renderMenuItems = () => {
    const menuItems = MENU_ITEMS.filter((item) => {
      if (_.includes(item.role, this.props.userInfo.roles[0])) {
        if (
          !_.isEmpty(item.permissionKey) &&
          this.props.userInfo.roles[0] === USER_ROLE
        ) {
          return !_.isEmpty(
            item.permissionKey.filter(
              (i) => this.props.userInfo.userPermissions[i]
            )
          );
        } else {
          return true;
        }
      } else {
        return false;
      }
    });

    if (!_.isEmpty(menuItems)) {
      if (_.isEmpty(this.props.currentKey)) {
        this.props.setNavigationKey(menuItems[0].key);
      }
    }

    return menuItems.map((menuOptions) => (
      <Menu.Item key={menuOptions.key}>
        <div>
          <Icon type={menuOptions.icon} />
          {menuOptions.title}
        </div>
      </Menu.Item>
    ));
  };

  render() {
    return (
      <div className='Menu target'>
        <Menu
          onClick={this.handleClick}
          selectedKeys={[this.props.currentKey]}
          mode='horizontal'
        >
          {!_.isEmpty(this.props.userInfo) && this.renderMenuItems()}
        </Menu>
      </div>
    );
  }
}

function mapStateToProps({ auth, navigationStore }) {
  return {
    userInfo: auth.userInfo,
    currentKey: navigationStore.currentKey
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setNavigationKey: bindActionCreators(setNavigationKey, dispatch)
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavigationBar)
);
